import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'gatsby-link'

import style from '../utils/styles'
import { rhythm } from '../utils/typography'
import sidebarShadow from '../assets/sidebar_shadow_flipped.png'
import FacebookProvider, { Page } from 'react-facebook';

import {Sidebar, Title, InfoBlock} from './layouts'
import {ButtonGreen} from './button'

const SideBarR = Sidebar.extend`

  @media (min-width: 800px) {
    background: url(${sidebarShadow}) right top no-repeat;
    margin-left: ${rhythm(0.25)};
    padding-right: ${rhythm(1)};
  }

`

const ButtonGreenSmall = ButtonGreen.extend`
  font-size: ${rhythm(0.5)};
  margin: ${rhythm(0.25)} auto;
`

class SideBarRight extends React.Component {

  render() {
    const {view} = this.props;
    return (
      <SideBarR>
        <Title>{view === 'yhteystiedot' ? 'YHTEYSTIEDOT': 'HINNASTO'}</Title>
        <InfoBlock full isGray>
          {view === 'net' && <div className="content-info">
            <p><strong>Yksilöterapia </strong></p>
            <p><strong>Sähköpostitse: 50 € </strong></p>
            <p><strong>Nettipuhelun avulla</strong></p>
            <p>Kesto: 45min<br />
            Hinta: 70€</p>

            <p><strong>Chatin avulla</strong></p>
            <p>Kesto: 45min.<br />
            Hinta: 70€</p>
            <p><strong>Puhelun avulla</strong></p>
            <p>Kesto: 45min.<br />
            Hinta: 70€</p>
          </div>}
          {view === 'tyonohjaus' && <div className="content-info">
            <p style={{textAlign: 'center'}}><strong>Työnohjauksen hinnat sovitaan erikseen</strong></p>
          </div>}
          {view === 'hinnasto' && <div className="content-info">
            <p style={{textAlign: 'center'}}><strong>Tervetuloa kokonaisvaltaiseen hoitoon!</strong></p>
          </div>}
          {!view && <div className="content-info">
            <p><strong>Yksilöpsykoterapiakäynti</strong></p>
            <p>Kesto: 45min<br />
            Hinta: 80€</p>
          </div>}
          {view !== 'yhteystiedot' && <ButtonGreenSmall to="/yhteystiedot">YHTEYSTIEDOT</ButtonGreenSmall>}
          {/* {view !== 'yhteystiedot' && <p><strong>Psykoterapiaa netissä </strong><br/>
            <Link to="/nettiterapia">Katso lisätiedot</Link>
          </p>} */}
          {view === 'yhteystiedot' && <div>
            <p>Terapiapalvelu Kirsti Louko </p>

            <p>Osoite: </p>

            <p>Ruukintie 25,<br/>
            60100 Seinäjoki </p>

            <p>Gsm. 050-528 8861 </p>

            <p>Email: <a href="mailto:info@kirstilouko.com">info@kirstilouko.com</a></p>

            </div>}
            </InfoBlock>

            {view !== 'yhteystiedot' && <FacebookProvider appId="114390019275615">
                <Page href="https://www.facebook.com/Terapiapalvelu-Kirsti-Louko-156979377673908/" width="285" />
              </FacebookProvider>}

      </SideBarR>
    )
  }

}

export default SideBarRight



// WEBPACK FOOTER //
// ./src/layouts/SideBarRight.js